<template>
  <div class="one-work">
    <article></article>
    <h2>
      BUSINESS COOPERATION
      <p>商务合作<span></span></p>
    </h2>
    <figure>
      <aside>
        <h3>健身房合作 <span></span></h3>
        <p>电话：4006-000-000</p>
        <p>邮箱：uuwyye@163.com</p>
      </aside>
      <aside>
        <h3>供应商合作 <span></span></h3>
        <p>电话：4006-000-000</p>
        <p>邮箱：uuwyye@163.com</p>
      </aside>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style lang="scss" scoped>
.one-work{
  height: 100%; 
  background-color: #0C1314;
  overflow: hidden;
  article{
    width: 400px;
    height: 400px;
    margin: 0;
    position: fixed;
    border: 60px solid;
    border-radius: 50%;
    left: calc(50% - 260px);
    top: -180px;
  }
  h2{
    font-size: 70px;
    margin: 150px auto 210px;
    background-image: linear-gradient(180deg, #E84140 0%, rgba(17, 27, 28, 0) 100%);
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    z-index: 9;
    position: relative;
    padding-bottom: 10px;
    opacity: .7;
    >p{
      color: #fff;
      font-size: 40px;
      margin: 0;
      font-weight: normal;
      position: absolute;
      bottom: 0;
      width: 100%;
      span{
        position: absolute;
        width: 50px;
        left: calc(50% - 25px);
        height: 2px;
        background: #E20A2F;
        bottom: -10px;
      }
    }
  }
  figure{
    margin: 0;
    background-color: #EDEFF1;
    height: 538px;
    position: relative;
    aside:first-child{
      left: 22%;
    }
    aside{
      position: absolute;
      bottom: 66%;
      width: 24%;
      right: 22%;
      height: 260px;
      background: #fff;
      border-radius: 20px;
      box-shadow: 0px 12px 0px 0px rgba(226, 10, 47, .8);
      display: flex;
      flex-direction: column;
      h3{
        margin: 13% 16%;
        font-size: 24px;
        position: relative;
        line-height: 50px;
        span{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 35px;
          height: 3px;
          background-color: #E20A2F;
        }
      }
      p{
        margin: 0 16%;
      }
    }
  }
}
</style>
